import { ChangeThemeButton } from "../../components/change-theme-button/change-theme-button";
import { PrimaryButton } from "../../components/primary-button/primary-button";
import { getListItems } from "../../constants";
import * as S from "./desktop-content.styles";
import { SearchInput } from "../../../search-input/search-input";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { Logo } from "../../../../components/logo/logo";
import type { NavbarVariantsProps } from "components/navbar/types";
import { useThemeSwitcher } from "../../../../context/theme/theme-context";
import { useState } from "react";
import { useStoreConfig } from "../../../../hooks/use-store-config";

export const DesktopContent = ({ toggleCart }: NavbarVariantsProps) => {
  const { toggleTheme } = useThemeSwitcher();
  const { trustPilot } = useStoreConfig();
  const [searchValue, setSearchValue] = useState('');
  const listItems = getListItems(trustPilot)

  return (
    <div>
      <S.RowWrapper $justify="space-between">
        <S.RowWrapper $justify="flex-start">
          <Logo />
          <SearchInput placeholder="Buscar produtos..." id="navbar-search-input" value={searchValue} onChange={(e) => setSearchValue(e)} />
        </S.RowWrapper>
        <S.ListWrapper>
          {listItems.map((item) => (
            <S.ListItem to={item.url} key={item.name} target={item.blankPage ? "_blank" : undefined}>
              {item.name}
            </S.ListItem>
          ))}
          <PrimaryButton label="Carrinho" aria-label="Abrir carrinho" icon={faShoppingCart} onClick={toggleCart} />
          <ChangeThemeButton label="Alterar tema" onClick={toggleTheme} />
        </S.ListWrapper>
      </S.RowWrapper>
    </div>
  );
};
